import React from 'react';
import cn from 'classnames';
import TextButton from '@wix/da-ds/pkg/Buttons/TextButton';
import ArrowRight from '@wix/da-ds/pkg/Icons/16x16/ArrowRight';

import s from './ChartPanelSkeleton.scss';

interface Props {
  className?: string;
  totalTitle: string;
  total: string;
  manageTitle: string;
  manageHref: string;
}

const ChartPanelSkeleton: React.FC<Props> = ({
  className,
  totalTitle,
  total,
  manageTitle,
  manageHref,
  children,
}) => {
  return (
    <div className={cn(s['root'], className)}>
      <div className={s['above']}>
        <div className={s['total']}>
          {totalTitle}
          <strong>{total}</strong>
        </div>
        <TextButton
          className={s['manage-btn']}
          size="small"
          variant="main"
          href={manageHref}
          postfixIcon={ArrowRight}
        >
          {manageTitle}
        </TextButton>
      </div>
      <div className={s['chart']}>{children}</div>
    </div>
  );
};
ChartPanelSkeleton.displayName = 'ChartPanelSkeleton';

export default ChartPanelSkeleton;
